export enum CustomButtonFilterStatus {
  Hide,
  Include,
  ShowOnly
}